// src/menu/sections/cronMenu.ts
import type { AppMenuEntry } from "../types";

export const CRON_MENU: AppMenuEntry = {
  type: "group",
  key: "cron",
  label: "Cron",
  children: [
    {
      key: "job",
      label: "Job",
      path: "/job",
      resource: "v_job",
      icon: "schedule",
    },
    {
      key: "job_run_details",
      label: "Job Run Details",
      path: "/job_run_details",
      resource: "v_job_run_details",
      icon: "history",
    },
  ],
};
